import React from 'react';
import './QuestionImage.scss';

import Config from '../../../../../../config/config';
import { closePreviewQuestionImgForms } from '../../../../adminSlice';
import {divideText} from '../../../../../../helper/dividerForTextNote';

const QuestionImage = (props) => {

    const { dispatch } = props;

    const serverPath = Config.serverPath;
            const questionImgName = props.adminState.selectedImgName;
       // const note_src = noteName? `${serverPath}/api/quizesimg/${selectedQuizId}/${item.img_path}`: null; 
        //const note_src = `${serverPath}/api/quizesimg/${props.quizRedux.quizId}/${props.quizRedux.questionImg}`; 
        const note_src = `${serverPath}/api/quizesimg/${props.adminState.selectedQuize}/${questionImgName}`;
    // CLOSE FORM
    const onClose = () => {

        dispatch(closePreviewQuestionImgForms());

    }



             //const note_src = `${serverPath}/api/quizesimg/13/$q_13_1234.jpg`;
            return (

                <div className="QuestionImage" >
                    <div className="Quiz-header">
      
                    </div>
                    <div className='question-block'>
                        {divideText(props.adminState.selectedQuestionContent)}
                    </div>
                    

                     <div className='img-container'>
                           
                             {questionImgName ? <img alt="note" src={note_src}/>  : null}
           
                    </div>
                    <button onClick={onClose}>Закрыть</button>

                   
                    
                </div>
              
            )
  
    
    
}

export default QuestionImage;